import React from "react";

function Template6() {
  const mockData = {
    tutor: {
      pagetitle: "AI Tutor: Scalable Student Support",
      content1:
        "AristAI's AI Tutor acts as a virtual teaching assistant that answers student questions instantly, using course materials and educator-defined knowledge to ensure accurate, context-aware responses.",
      content2:
        "Integrated directly into the learning environment, the AI Tutor is always available—reducing the burden on educators and helping students stay engaged between classes.",
      section1: {
        subsection1: "Context-Aware Q&A",
        subsection2:
          "Students can ask natural-language questions and receive tailored answers based on course slides, lecture notes, or custom documents provided by the instructor.",
        subsection3:
          "This ensures that the AI support is not generic but deeply aligned with the specific curriculum being taught.",
      },
      section2: {
        subsection1: "Instructor Control",
        subsection2:
          "Educators retain full control by uploading approved materials, tuning tone and accuracy, and even reviewing usage analytics to improve teaching.",
        subsection3:
          "This enables safe, consistent AI support aligned with academic integrity standards.",
      },
    },
  };

  const handleGoBack = () => {
    window.location.href = "/";
  };

  return (
    <div style={{ ...styles.container, ...styles.fadeIn }}>
      <button onClick={handleGoBack} style={styles.closeButton} aria-label="Close and return to home">
        ✕
      </button>
      {/* Left Section */}
      <div style={styles.leftSection}>
        <h1 style={styles.mainTitle}>{mockData.tutor.pagetitle}</h1>
        <p style={styles.description}>{mockData.tutor.content1}</p>
        <p style={styles.description}>{mockData.tutor.content2}</p>
        <img src="https://d2hp1ftv5ri2om.cloudfront.net/assets/landing/tutor.png" alt="AristAI Logo" style={{
          width: "100%",
          maxWidth: "300px",
          marginTop: "2rem",
          borderRadius: "8px",
        }} />
      </div>

      {/* Right Section */}
      <div style={styles.rightSection}>
        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.tutor.section1.subsection1}</h2>
            <p style={styles.text}>{mockData.tutor.section1.subsection2}</p>
            <p style={styles.text}>{mockData.tutor.section1.subsection3}</p>
          </div>
        </div>

        <div style={styles.contentBox}>
          <div style={styles.iconBox}></div>
          <div style={styles.textContent}>
            <h2 style={styles.heading}>{mockData.tutor.section2.subsection1}</h2>
            <p style={styles.text}>{mockData.tutor.section2.subsection2}</p>
            <p style={styles.text}>{mockData.tutor.section2.subsection3}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    backgroundColor: "#000",
    color: "#fff",
    minHeight: "100vh",
    padding: "3rem",
    gap: "4rem",
    margin: "0 auto",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
  },
  fadeIn: {
    animation: "fadeInFromLeft 0.8s ease-out forwards",
    opacity: 0,
  },
  leftSection: {
    flex: "1",
    paddingTop: "2rem",
  },
  rightSection: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    paddingTop: "4rem",
  },
  mainTitle: {
    fontSize: "3.5rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    lineHeight: "1.2",
  },
  description: {
    fontSize: "1.1rem",
    lineHeight: "1.6",
    color: "#999",
    marginBottom: "1rem",
  },
  contentBox: {
    display: "flex",
    gap: "1.5rem",
    alignItems: "flex-start",
  },
  iconBox: {
    width: "48px",
    height: "48px",
    backgroundColor: "#333",
    borderRadius: "8px",
    flexShrink: 0,
  },
  textContent: {
    flex: "1",
  },
  heading: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    marginTop: "0",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.6",
    color: "#999",
  },
  closeButton: {
    position: "absolute",
    top: "20px",
    right: "20px",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "transparent",
    border: "1px solid #fff",
    color: "#fff",
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    zIndex: 10,
  },
};

// Add the keyframes animation to the document
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes fadeInFromLeft {
    from {
      opacity: 0;
      transform: translateX(-50px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
document.head.appendChild(styleSheet);

export default Template6;
